import { Link } from 'react-router-dom';
import { Camera, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { adminButton } from '@/components/admin/ui';

interface PhotoReportsUpgradeProps {
  /** Owners get the upgrade button; everyone else is told who to ask. */
  canUpgrade: boolean;
  compact?: boolean;
}

/** Shown on Solo in place of before/after photos and completion reports. */
export function PhotoReportsUpgrade({ canUpgrade, compact }: PhotoReportsUpgradeProps) {
  return (
    <div
      data-testid="photo-reports-upgrade"
      className="flex flex-col gap-3 rounded-xl border border-dashed border-primary/30 bg-secondary/40 p-4 sm:flex-row sm:items-center"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
        <Camera className="h-4 w-4" aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[13.5px] font-semibold text-foreground">Before and after photos</p>
        {!compact && (
          <p className="text-[12.5px] text-muted-foreground">
            Snap the job before and after, and send your customer a tidy completion report with the checklist and photos.
            Included on the Team and Business plans.
          </p>
        )}
      </div>
      {canUpgrade ? (
        <Button asChild size="sm" className={adminButton.primary}>
          <Link to="/admin/billing">
            <Sparkles />
            Upgrade to Team
          </Link>
        </Button>
      ) : (
        <p className="text-[12px] text-muted-foreground">Ask the business owner about upgrading.</p>
      )}
    </div>
  );
}
